// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import {
  BottomNavigation as Navigation,
  BottomNavigationAction,
  styled,
} from "@3778.care/goban";
import { useLocation, useNavigate } from "react-router-dom";

import { useGetButtons } from "./buttons";

const StyledNavigation = styled(Navigation)(({ theme: { shadows } }) => ({
  position: "fixed",
  width: "100%",
  top: "auto",
  bottom: 0,
  boxShadow: shadows[5],
}));

export const BottomNavigation = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const buttons = useGetButtons({ isDesktop: false, pathname });

  return (
    <StyledNavigation
      onChange={(_, newValue) => navigate(newValue)}
      showLabels
      value={pathname}
    >
      {buttons.map((button) => (
        <BottomNavigationAction {...button} key={button.value} />
      ))}
    </StyledNavigation>
  );
};
